export const MENU_PARTS = [
  'item',
  'command',
  'list',
  'button',
  'groupTitle',
  'divider',
] as const;
